import Box from 'carbon-react/esm/components/box';
import Typography from 'carbon-react/esm/components/typography';

export default function PageNoResult() {
  return (
    <Box data-component="page-no-result" width="100%" height="100%" backgroundColor="white">
      <Box
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="center"
        gap={4}
        height="100%"
        minHeight="300px"
        padding={4}
      >
        <Box maxWidth="100%">
          <img
            src="sage-noresult.svg"
            alt=""
            style={{ display: 'block', height: 'auto', maxWidth: '100%' }}
          />
        </Box>
        <Box>
          <Typography variant="h2" pb={2}>
            Il n&apos;y a pas de résultat
          </Typography>
          <Typography variant="p" m={0}>
            Nous vous invitons à modifier vos critères de recherche.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
